const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Throttle function to limit scroll event execution
function throttle(fn, wait = 100) {
  let lastTime = 0;
  return function (...args) {
    const now = Date.now();
    if (now - lastTime >= wait) {
      fn.apply(this, args);
      lastTime = now;
    }
  };
}

// Scroll-in animation logic
function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false,
) {
  const elements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
  );
  if (elements.length === 0) return;

  if (isDesignModeEvent) {
    elements.forEach((el) => el.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry, index) => {
        const el = entry.target;
        if (entry.isIntersecting) {
          el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
          if (el.hasAttribute('data-cascade')) {
            el.style.setProperty('--animation-order', index);
          }
          observer.unobserve(el);
        } else {
          el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
          el.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
        }
      });
    },
    {
      rootMargin: '0px 0px -50px 0px',
    },
  );

  elements.forEach((el) => {
    el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    observer.observe(el);
  });
}

// Zoom-in scroll animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const elements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME),
  );
  if (elements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  // Initial set
  updateZoomAnimations(elements, scaleAmount);

  // Batch scroll update
  window.addEventListener(
    'scroll',
    throttle(() => {
      updateZoomAnimations(elements, scaleAmount);
    }, 100),
    {passive: true},
  );
}

function updateZoomAnimations(elements, scaleAmount) {
  elements.forEach((element) => {
    const ratio = 1 + scaleAmount * percentageSeen(element);
    element.style.setProperty('--zoom-in-ratio', ratio);
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const rect = element.getBoundingClientRect();
  const elementTop = rect.top + scrollY;
  const elementHeight = rect.height;

  if (elementTop > scrollY + viewportHeight) return 0;
  if (elementTop + elementHeight < scrollY) return 100;

  const distance = scrollY + viewportHeight - elementTop;
  const percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

// Initialize on page load
window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

// Re-initialize on Shopify section changes
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) =>
    initializeScrollAnimationTrigger(e.target, true),
  );
  document.addEventListener('shopify:section:reorder', () =>
    initializeScrollAnimationTrigger(document, true),
  );
}
